import { CheckCircleOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, InfoCircleOutlined, StopOutlined } from "@ant-design/icons";
import { Modal, PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarRelojChecador from "./AgregarRelojChecador/AgregarRelojChecador";
import EditarRelojChecador from "./EditarRelojChecador/EditarRelojChecador";
import InformacionRelojChecador from "./InformacionRelojChecador/InformacionRelojChecador";
import IconArrowsShuffle from "../../../Icons/IconArrowsShuffle";

moment.locale("es");

class RelojesChecadores extends Component {
    tableRef = null;
    state = {
        todasRelojesChecadores: [],
        loading: false,
        valor: 1,
        modalAgregarRelojChecador: false,
        modalEditarRelojChecador: false,
        modalEditarRelojChecadorId: null,
        modalInformacionRelojChecador: false,
        modalInformacionRelojChecadorId: null,
    };
    consultarRelojesChecadores(params) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/selectTodasRelojesChecadores",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasRelojesChecadores: [] });
                } else {
                    this.setState({
                        todasRelojesChecadores: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarRelojChecador(value) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/deshabilitarRelojChecador",
                { relojChecadorId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Reloj checador deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarRelojChecador(value) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/habilitarRelojChecador",
                { relojChecadorId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Reloj checador habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    sincronizarRelojChecador(id) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/sincronizarRelojChecador",
                { relojChecadorId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha sincronizado el reloj checador");
                } else if (res.data.success === 1) {
                    message.error("No se pudo sincronizar el reloj checador");
                } else {
                    message.error("Hubo un error y el reloj checador no se sincronizó");
                }
            });
    }

    consultarInformacionRelojChecador(id) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/consultarInformacionRelojChecador",
                { relojChecadorId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    this.setState({ modalInformacionRelojChecador: true, modalInformacionRelojChecadorId: id });
                } else {
                    message.error(res.data.message || "No se pudo consultar la información del reloj");
                }
            });
    }
    cerrarInformacionRelojChecador() {
        this.setState({ modalInformacionRelojChecador: false, modalInformacionRelojChecadorId: null });
    }

    borrarDatosRelojChecador(id) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/borrarDatosRelojChecador",
                { relojChecadorId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se han borrado los datos del reloj checador");
                } else if (res.data.success === 1) {
                    message.error("No se pudieron borrar los datos del reloj checador");
                } else {
                    message.error("Hubo un error y no se borraron los datos del reloj checador");
                }
            });
    }

    agregarRelojChecador() {
        this.setState({ modalAgregarRelojChecador: true });
    }
    cerrarAgregarRelojChecador() {
        this.setState({ modalAgregarRelojChecador: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarRelojChecador(id) {
        this.setState({ modalEditarRelojChecador: true, modalEditarRelojChecadorId: id });
    }
    cerrarEditarRelojChecador() {
        this.setState({ modalEditarRelojChecador: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Última conexión",
                dataIndex: "ultimaConexionAt",
                key: "ultimaConexionAt",
                align: "center",
                width: "12%",
                render: (value) => {

                    if (!value) {
                        return (
                            <div style={{ textAlign: "right" }}>
                                <div style={{ fontSize: "12px", color: "#999" }}>
                                    Sin conexión
                                </div>
                            </div>
                        );
                    }

                    const ahora = moment();
                    const ultima = moment(value);
                    const diffMin = ahora.diff(ultima, "minutes");

                    let color = "#ff4d4f"; // rojo default

                    if (diffMin <= 15) {
                        color = "#52c41a"; // verde
                    } else if (diffMin <= 60) {
                        color = "#faad14"; // naranja
                    }

                    return (
                        <div style={{ textAlign: "center" }}>
                            {/* Hace cuánto */}
                            <div
                                style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: color,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px"
                                }}
                            >
                                <span>{ultima.fromNow()}</span>
                            </div>

                            {/* Hora exacta */}
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#666",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px"
                                }}
                            >
                                <span>{ultima.format("DD/MM/YYYY HH:mm:ss")}</span>
                            </div>
                        </div>
                    );
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarRelojChecador) {
                        buttons.push(
                            <Tooltip
                                title="Editar Reloj Checador"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarRelojChecador(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarRelojChecador) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar este reloj checador?"
                                    onConfirm={() => this.deshabilitarRelojChecador(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                            buttons.push(
                                <Tooltip
                                    key={`sincronizar-${record._id}`}
                                    title="Sincronizar Reloj Checador"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rosa
                                        icon={<span style={{ fontSize: '16px', display: 'flex', alignItems: 'center' }}><IconArrowsShuffle size={16} stroke={2.5} /></span>}
                                        onClick={() => Modal.confirm({
                                            title: 'Sincronizar Reloj Checador',
                                            icon: <ExclamationCircleOutlined />,
                                            content: 'Se borrarán y volverán a darse de alta todos los usuarios del reloj. ¿Deseas continuar?',
                                            okText: 'Sí, sincronizar',
                                            okType: 'primary',
                                            cancelText: 'Cancelar',
                                            onOk: () => this.sincronizarRelojChecador(record._id),
                                        })}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                            buttons.push(
                                <Tooltip
                                    key={`informacion-${record._id}`}
                                    title="Consultar Información del Reloj"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        icon={<InfoCircleOutlined />}
                                        onClick={() => this.consultarInformacionRelojChecador(record._id)}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                            buttons.push(
                                <Tooltip
                                    key={`borrar-${record._id}`}
                                    title="Borrar Datos Reloj"
                                    placement="top"
                                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                >
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<DeleteOutlined />}
                                        onClick={() => Modal.confirm({
                                            title: 'Borrar Datos del Reloj Checador',
                                            icon: <ExclamationCircleOutlined />,
                                            content: 'Se borrarán todos los usuarios del reloj checador. Esta acción no se puede deshacer. ¿Deseas continuar?',
                                            okText: 'Sí, borrar',
                                            okType: 'danger',
                                            cancelText: 'Cancelar',
                                            onOk: () => this.borrarDatosRelojChecador(record._id),
                                        })}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar este reloj checador?"
                                    onConfirm={() => this.habilitarRelojChecador(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Relojes Checadores"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarRelojChecador && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarRelojChecador"
                                    onClick={this.agregarRelojChecador.bind(this)}
                                >
                                    Agregar Reloj Checador
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarRelojesChecadores.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasRelojesChecadores}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"relojesChecadores" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarRelojChecador) {
                                this.editarRelojChecador(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarRelojChecador
                    visible={this.state.modalAgregarRelojChecador}
                    cerrarAgregarRelojChecador={this.cerrarAgregarRelojChecador.bind(this)}
                />
                <EditarRelojChecador
                    visible={this.state.modalEditarRelojChecador}
                    relojChecadorId={this.state.modalEditarRelojChecadorId}
                    cerrarEditarRelojChecador={this.cerrarEditarRelojChecador.bind(this)}
                />
                <InformacionRelojChecador
                    visible={this.state.modalInformacionRelojChecador}
                    relojChecadorId={this.state.modalInformacionRelojChecadorId}
                    cerrarInformacionRelojChecador={this.cerrarInformacionRelojChecador.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarRelojChecador: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f0204f7899dda241377ce2")?.activado,
        permisoEditarRelojChecador: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020627899dda241377ce3")?.activado,
        permisoDeshabilitarRelojChecador: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f020717899dda241377ce4")?.activado,
    };
};

export default connect(mapStateToProps)(RelojesChecadores);
